<template>
  <div class="crm-page">
    <div class="crm-hero">
      <div>
        <div class="crm-eyebrow">客户管理CRM</div>
        <h2>待办提醒</h2>
        <p>
          按首次联系、加微信、回访、掉公海、审批待处理等维度提醒员工和主管，并支持点击进入对应客户列表。
        </p>
      </div>
      <div class="crm-actions">
        <el-button type="primary" @click="goMyCustomers"
          >进入我的客户</el-button
        >
      </div>
    </div>

    <div class="todo-grid">
      <div
        v-for="item in todoCards"
        :key="item.key"
        class="todo-card"
        :class="item.level"
        @click="selectCard(item)"
      >
        <span>{{ item.label }}</span>
        <strong>{{ item.count }}</strong>
        <small>{{ item.tip }}</small>
      </div>
    </div>

    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>{{ activeCard.label }}列表</span>
        <div>
          <el-tag :type="activeCard.levelType" size="mini">{{
            activeCard.tip
          }}</el-tag>
          <el-button
            type="text"
            style="margin-left: 10px"
            @click="jumpToFilteredList"
            >跳到客户列表</el-button
          >
        </div>
      </div>
      <el-table :data="activeList" stripe border>
        <el-table-column
          prop="name"
          label="客户姓名"
          min-width="120"
        ></el-table-column>
        <el-table-column label="手机号" min-width="160">
          <template slot-scope="scope">
            <crm-phone-field :phone="scope.row.phone" status="pending" />
          </template>
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="公司名称"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="mainStatus"
          label="主状态"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="intentionLevel"
          label="意向等级"
          width="100"
        ></el-table-column>
        <el-table-column
          prop="lastFollowTime"
          label="最近跟进时间"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="nextFollowTime"
          label="下次跟进时间"
          min-width="140"
        ></el-table-column>
        <el-table-column
          prop="publicPoolCountdown"
          label="掉公海剩余"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag
              size="mini"
              :type="scope.row.publicPoolCountdown <= 0 ? 'danger' : 'warning'"
            >
              {{
                scope.row.publicPoolCountdown <= 0
                  ? "已超期"
                  : scope.row.publicPoolCountdown + " 天"
              }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card shadow="never">
      <div slot="header">提醒说明</div>
      <div class="todo-note">
        <p><b>橙色</b>：表示待跟进、待加微信、待回访等需要优先处理的动作。</p>
        <p>
          <b>红色</b>：表示已超期、即将掉公海或高优先级风险客户，需要尽快处理。
        </p>
        <p><b>蓝色</b>：表示审批待处理等管理动作，建议主管每日检查一次。</p>
      </div>
    </el-card>
  </div>
</template>

<script>
import { loadCrmState } from "./mock";
import CrmPhoneField from "./PhoneField.vue";

function todayString() {
  const now = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate()
  )}`;
}

export default {
  name: "CrmTodo",
  components: { CrmPhoneField },
  data() {
    return {
      state: loadCrmState(this.$store.getters.GET_TITLE || "当前员工"),
      activeKey: "first",
    };
  },
  computed: {
    ownerName() {
      return this.$store.getters.GET_TITLE || "当前员工";
    },
    myCustomers() {
      return (this.state.customers || []).filter(
        (item) =>
          item.ownerName === this.ownerName && item.poolType === "私人池"
      );
    },
    todoMap() {
      const today = todayString();
      return {
        first: this.myCustomers.filter((item) => !item.firstCallDone),
        wechat: this.myCustomers.filter(
          (item) => item.intentionLevel === "A高意向" && !item.hasWeChat
        ),
        revisit: this.myCustomers.filter((item) =>
          String(item.nextFollowTime || "").startsWith(today)
        ),
        toPublic: this.myCustomers.filter(
          (item) =>
            item.publicPoolCountdown > 0 && item.publicPoolCountdown <= 2
        ),
        overdue: this.myCustomers.filter(
          (item) => item.publicPoolCountdown <= 0
        ),
        wechatUnsigned: this.myCustomers.filter(
          (item) => item.hasWeChat && item.mainStatus !== "已签约"
        ),
        approval: [],
        priority: this.myCustomers.filter(
          (item) => item.intentionLevel === "A高意向"
        ),
      };
    },
    todoCards() {
      return [
        {
          key: "first",
          label: "待首次联系",
          count: this.todoMap.first.length,
          tip: "新客户必须尽快首呼",
          level: "warning",
          levelType: "warning",
          tab: "todayAssigned",
        },
        {
          key: "wechat",
          label: "待加微信",
          count: this.todoMap.wechat.length,
          tip: "有意向但未加微信",
          level: "warning",
          levelType: "warning",
          tab: "wechat",
        },
        {
          key: "revisit",
          label: "待回访",
          count: this.todoMap.revisit.length,
          tip: "今日需执行回访",
          level: "warning",
          levelType: "warning",
          tab: "todayFollow",
        },
        {
          key: "toPublic",
          label: "即将掉公海",
          count: this.todoMap.toPublic.length,
          tip: "保护期即将结束",
          level: "danger",
          levelType: "danger",
          tab: "toPublic",
        },
        {
          key: "overdue",
          label: "已超期未跟进",
          count: this.todoMap.overdue.length,
          tip: "已触发风险",
          level: "danger",
          levelType: "danger",
          tab: "overdue",
        },
        {
          key: "wechatUnsigned",
          label: "已加微信未签约",
          count: this.todoMap.wechatUnsigned.length,
          tip: "需要持续推进签约",
          level: "warning",
          levelType: "warning",
          tab: "awaitSign",
        },
        {
          key: "approval",
          label: "审批待处理",
          count: (this.state.approvals || []).filter(
            (item) => item.status === "待审批"
          ).length,
          tip: "主管侧重点关注",
          level: "primary",
          levelType: "primary",
          tab: "all",
        },
        {
          key: "priority",
          label: "高优先级客户",
          count: this.todoMap.priority.length,
          tip: "A 级客户重点维护",
          level: "danger",
          levelType: "danger",
          tab: "highIntent",
        },
      ];
    },
    activeCard() {
      return (
        this.todoCards.find((item) => item.key === this.activeKey) ||
        this.todoCards[0]
      );
    },
    activeList() {
      return this.todoMap[this.activeKey] || [];
    },
  },
  methods: {
    selectCard(item) {
      this.activeKey = item.key;
    },
    jumpToFilteredList() {
      if (this.activeKey === "approval") {
        this.$router.push("/crm/approvals");
        return;
      }
      this.$router.push({
        path: "/crm/my-customers",
        query: { tab: this.activeCard.tab || "all" },
      });
    },
    goMyCustomers() {
      this.$router.push("/crm/my-customers");
    },
  },
};
</script>

<style scoped>
.crm-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.crm-hero {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  padding: 24px 28px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #e8edf5;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.04);
}
.crm-eyebrow {
  display: inline-flex;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(64, 158, 255, 0.12);
  color: #409eff;
  font-size: 12px;
  font-weight: 700;
}
.crm-hero h2 {
  margin: 12px 0 0;
  font-size: 28px;
  color: #111827;
}
.crm-hero p {
  margin: 10px 0 0;
  color: #6b7280;
  line-height: 1.7;
}
.crm-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.todo-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
}
.todo-card {
  padding: 18px 20px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid #e8edf5;
  cursor: pointer;
}
.todo-card span {
  display: block;
  color: #6b7280;
  font-size: 13px;
}
.todo-card strong {
  display: block;
  margin-top: 8px;
  font-size: 32px;
  color: #111827;
}
.todo-card small {
  display: block;
  margin-top: 10px;
  color: #9ca3af;
}
.todo-card.warning {
  background: #fffaf0;
}
.todo-card.danger {
  background: #fff6f6;
}
.todo-card.primary {
  background: #eff6ff;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.todo-note {
  color: #4b5563;
  line-height: 1.9;
}
@media (max-width: 1200px) {
  .crm-hero {
    flex-direction: column;
    align-items: flex-start;
  }
  .todo-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
